<div class="settings__query-container">
  <div class="settings__search">
    <input
      type="text"
      class="settings__search-input"
      placeholder="Search by setting name..."
      [(ngModel)]="searchText"
      (input)="onSearchChange()" />
  </div>
</div>

<div>
  <div class="settings__actions">

    <div
      *renderingPermissionDirective="['SettingTypeAdmin']"
      class="settings__modify-settings">
      <ng-container *ngIf="isDevEnv">
        <button
          class="lx-btn-small lx-btn-primary"
          type="button"
          (click)="openCreateNewSettingModal()">
          Create New Setting
        </button>
      </ng-container>
    </div>

    <div class="settings__refresh-container">
      <div class="settings__refresh">
        <button
          class="lx-btn-small lx-btn-text settings__refresh"
          (click)="onRefresh()">
          <i class="lx-icon lx-reset"></i>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="settings__data">
    <ag-grid-angular
      #grid
      class="ag-theme-alpine ag-grid-sticky-header"
      domLayout="autoHeight"
      style="width: 100%; height: 100%"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [enableCellTextSelection]="true"
      [ensureDomOrder]="true"
      [rowSelection]="'single'"
      [suppressRowHoverHighlight]="false"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"></ag-grid-angular>
  </div>
</div>
